import {Injectable} from '@angular/core';
import {Http, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FileService {

  constructor(private http: Http) {}

  downloadFile(): Observable<any>{
		return this.http.get('/assets/pdf/CFF_donate_by_mail_form.pdf', {responseType: ResponseContentType.ArrayBuffer});
  }
   
}
